import {IonContent, IonHeader, IonPage, useIonRouter} from "@ionic/react";
import {HeaderComponent} from "../components";
import {routes} from "../route/constants";
import {MigrateSystemBModal} from "../modals/migrateSystemBModals";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";

export const MigrateSystemB = () => {
  // SCORZA-703: was `useHistory().length > 1`, which never fired under
  // history@5 (no `length`) and reads the raw webview session history under
  // history@4. Ionic's canGoBack() tracks in-app navigation, and is what the
  // rest of the app uses.
  const router = useIonRouter();
  const [isOpen, setIsOpen ] = useState(true);
  const { t } = useTranslation();
  const onDismiss = () => {
    setIsOpen(false);
    if(router.canGoBack()) {
      router.goBack();
      return;
    }
    router.push(routes.tabResults);
  }
  return (
    <IonPage>
      <IonHeader>
        <HeaderComponent
          showBackButton={true}
          title={t("sinbinChanges.title")}
        />
      </IonHeader>
      <IonContent>
        <MigrateSystemBModal isOpen={isOpen} onDismiss={onDismiss}/>

      </IonContent>
    </IonPage>

      )
}